import React, { useState } from "react";
import {
  Search,
  Calendar,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Eye,
  X,
  Check,
  Gift,
  Layers,
  ShieldCheck,
  User,
  Settings,
} from "lucide-react";
import AhmedAvatar from "../../../assets/images/alert2 1 (1).png";
import "./LoyaltyLogs.css";

const SUB_TABS = [
  "All",
  "Members",
  "Rewards",
  "Tiers",
  "Points Rules",
  "Settings",
  "System",
  "Errors",
];

const MODULE_META = {
  Rewards: { icon: Gift, color: "#14B8A6", bg: "#E6F7F4" },
  Tiers: { icon: Layers, color: "#F0B90B", bg: "#FEF6E0" },
  "Points Rules": { icon: ShieldCheck, color: "#F97066", bg: "#FDEBEC" },
  Members: { icon: User, color: "#3B82F6", bg: "#EAF1FD" },
  Settings: { icon: Settings, color: "#6B7280", bg: "#F3F4F6" },
};

const ACTIVITY_LOGS = [
  {
    id: "Act-12551",
    date: "May 17, 2025",
    time: "10:32 am",
    module: "Rewards",
    action: "Updated",
    target: "Free Car Wash",
    targetSub: "Reward",
    performedBy: "Ahmed Mohamed",
    performedByType: "user",
    source: "Manual",
    status: "Success",
    reason: "Reward details were edited by admin.",
    previousValue: null,
    newValue: null,
    ip: "192.168.145",
    note: "-",
  },
  {
    id: "Act-12548",
    date: "May 17, 2025",
    time: "09:10 am",
    module: "Tiers",
    action: "Upgrade",
    target: "Ahmed Mohamed",
    targetSub: "From Silver to Gold",
    performedBy: "System",
    performedByType: "system",
    source: "Automatic",
    status: "Success",
    reason: "Qualified after earning 10,000 points.",
    previousValue: "Silver",
    newValue: "Gold",
    ip: "192.168.145",
    note: "-",
  },
  {
    id: "Act-12539",
    date: "May 16, 2025",
    time: "04:25 am",
    module: "Points Rules",
    action: "Created",
    target: "Spend & Earn",
    targetSub: "Spend Rule",
    performedBy: "Sara Ahmed",
    performedByType: "user",
    source: "Manual",
    status: "Success",
    reason: "New spend rule was created.",
    previousValue: null,
    newValue: null,
    ip: "192.168.145",
    note: "-",
  },
  {
    id: "Act-12530",
    date: "May 16, 2025",
    time: "11:40 am",
    module: "Members",
    action: "Manual Adjustment",
    target: "Mona Salah",
    targetSub: "+1,000 Points",
    performedBy: "Mona Salah",
    performedByType: "user",
    source: "Manual",
    status: "Success",
    reason: "Points added manually as compensation.",
    previousValue: null,
    newValue: null,
    ip: "192.168.145",
    note: "-",
  },
  {
    id: "Act-12521",
    date: "May 15, 2025",
    time: "10:32 am",
    module: "Rewards",
    action: "Activated",
    target: "10% Discount",
    targetSub: "Coupon",
    performedBy: "Ahmed Mohamed",
    performedByType: "user",
    source: "Manual",
    status: "Success",
    reason: "Coupon was activated for all members.",
    previousValue: null,
    newValue: null,
    ip: "192.168.145",
    note: "-",
  },
  {
    id: "Act-12512",
    date: "May 14, 2025",
    time: "11:32 am",
    module: "Tiers",
    action: "Downgrade",
    target: "Sara Ahmed",
    targetSub: "From Gold to Silver",
    performedBy: "System",
    performedByType: "system",
    source: "Automatic",
    status: "Success",
    reason: "Spend fell below the Gold retention threshold.",
    previousValue: "Gold",
    newValue: "Silver",
    ip: "192.168.145",
    note: "-",
  },
  {
    id: "Act-12503",
    date: "May 14, 2025",
    time: "05:32 pm",
    module: "Settings",
    action: "Updated",
    target: "Points Expiry Period",
    targetSub: "Setting",
    performedBy: "Ahmed Mohamed",
    performedByType: "user",
    source: "Manual",
    status: "Success",
    reason: "Expiry period was changed for all points.",
    previousValue: null,
    newValue: null,
    ip: "192.168.145",
    note: "-",
  },
];

export default function LoyaltyLogs() {

  const [activeSubTab, setActiveSubTab] = useState("All");
  const [perPage, setPerPage] = useState(7);
  const [page, setPage] = useState(1);
  const [selectedLog, setSelectedLog] = useState(null);

  const totalPages = 10;
  const pageNumbers = [1, 2, 3];

  return (
    <div className="ll-page-wrapper">
      {/* Section title */}
      <h3 className="ll-section-title">All Activity Logs</h3>
      {/* Filters */}
      <div className="ll-filters-row">
        <div className="ll-search-box">
          <Search size={16} color="#9CA3AF" />
          <input type="text" placeholder="Search activities.." />
        </div>

        <div className="ll-filters-right">
          <div className="ll-filter-group">
            <label className="ll-filter-label">Action Type</label>
            <button className="ll-filter-select">
              <span>All</span>
              <ChevronDown size={14} />
            </button>
          </div>
          <div className="ll-filter-group">
            <label className="ll-filter-label">Performed By</label>
            <button className="ll-filter-select">
              <span>All</span>
              <ChevronDown size={14} />
            </button>
          </div>
          <div className="ll-filter-group">
            <label className="ll-filter-label">Status</label>
            <button className="ll-filter-select">
              <span>All</span>
              <ChevronDown size={14} />
            </button>
          </div>
          <div className="ll-filter-group">
            <label className="ll-filter-label">Date Range</label>
            <button className="ll-date-range-btn">
              <span>May 01, 2025 - May 31, 2025</span>
              <Calendar size={15} color="#6B7280" />
            </button>
          </div>
        </div>
      </div>
      {/* Sub tabs */}
      <div className="ll-sub-tabs">
        {SUB_TABS.map((t) => (
          <button
            key={t}
            className={`ll-sub-tab ${activeSubTab === t ? "active" : ""}`}
            onClick={() => setActiveSubTab(t)}
          >
            {t}
          </button>
        ))}
      </div>
      {/* Table */}
      <div className="ll-table-card">
        <div className="ll-table-wrapper">
          <table className="ll-data-table">
            <thead>
              <tr>
                <th className="ll-th-left">Time</th>
                <th className="ll-th-left">Module</th>
                <th className="ll-th-left">Action</th>
                <th className="ll-th-left">Target</th>
                <th className="ll-th-left">Performed By</th>
                <th className="ll-th-left">Source</th>
                <th className="ll-th-left">Status</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {ACTIVITY_LOGS.map((log) => {
                const meta = MODULE_META[log.module];
                const ModuleIcon = meta.icon;
                return (
                  <tr key={log.id}>
                    <td className="ll-time-cell">
                      <div>{log.date}</div>
                      <div className="ll-time-sub">{log.time}</div>
                    </td>
                    <td>
                      <div className="ll-module-cell">
                        <span
                          className="ll-module-icon"
                          style={{ backgroundColor: meta.bg }}
                        >
                          <ModuleIcon size={15} color={meta.color} />
                        </span>
                        <span>{log.module}</span>
                      </div>
                    </td>
                    <td>{log.action}</td>
                    <td>
                      <div className="ll-target-cell">
                        <span>{log.target}</span>
                        <span className="ll-target-sub">{log.targetSub}</span>
                      </div>
                    </td>
                    <td>
                      <div className="ll-performed-cell">
                        {log.performedByType === "system" ? (
                          <span className="ll-performed-icon ll-performed-icon-system">
                            <Settings size={14} color="#6B7280" />
                          </span>
                        ) : (
                          <img
                            src={AhmedAvatar}
                            alt={log.performedBy}
                            className="ll-performed-avatar"
                          />
                        )}
                        <span>{log.performedBy}</span>
                      </div>
                    </td>
                    <td>{log.source}</td>
                    <td>
                      <span className="ll-status-badge">
                        <Check size={12} /> {log.status}
                      </span>
                    </td>
                    <td className="ll-details-cell">
                      <button
                        className="ll-eye-btn"
                        onClick={() => setSelectedLog(log)}
                      >
                        <Eye size={16} color="#6B7280" />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="ll-table-footer">
          <span className="ll-showing-text">
            Showing {ACTIVITY_LOGS.length} of {ACTIVITY_LOGS.length} of 12,584
            activites
          </span>
          <div className="ll-footer-right">
            <button className="ll-perpage-select">
              {perPage} per page <ChevronDown size={14} />
            </button>
            <div className="ll-pagination">
              <button
                className="ll-page-arrow"
                disabled={page === 1}
                onClick={() => setPage((p) => Math.max(1, p - 1))}
              >
                <ChevronLeft size={16} />
              </button>
              {pageNumbers.map((n) => (
                <button
                  key={n}
                  className={`ll-page-btn ${page === n ? "active" : ""}`}
                  onClick={() => setPage(n)}
                >
                  {n}
                </button>
              ))}
              <span className="ll-page-ellipsis">...</span>
              <button
                className={`ll-page-btn ${page === totalPages ? "active" : ""}`}
                onClick={() => setPage(totalPages)}
              >
                {totalPages}
              </button>
              <button
                className="ll-page-arrow"
                disabled={page === totalPages}
                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
              >
                <ChevronRight size={16} />
              </button>
            </div>
          </div>
        </div>
      </div>
      <ActivityDetailsDrawer
        log={selectedLog}
        onClose={() => setSelectedLog(null)}
      />
    </div>
  );
}

function ActivityDetailsDrawer({ log, onClose }) {

  if (!log) return null;
  const meta = MODULE_META[log.module];
  const ModuleIcon = meta.icon;

  return (
    <div className="lld-overlay" onClick={onClose}>
      <div className="lld-drawer" onClick={(e) => e.stopPropagation()}>
        <button className="lld-close-btn" onClick={onClose}>
          <X size={16} color="#fff" />
        </button>

        <h3 className="lld-title">Activity Details</h3>

        <div className="lld-heading-row">
          <span className="lld-activity-name">
            {log.module === "Tiers"
              ? `Tier ${log.action}`
              : `${log.module} ${log.action}`}
          </span>
          <span className="lld-status-badge">
            <Check size={13} /> {log.status}
          </span>
        </div>
        <div className="lld-activity-id">Activity ID: {log.id}</div>

        <h4 className="lld-section-title">Activity Information</h4>

        <div className="lld-field">
          <span className="lld-label">Date &amp; Time</span>
          <span className="lld-value">
            {log.date} - {log.time}
          </span>
        </div>

        <div className="lld-field">
          <span className="lld-label">Performed By</span>
          <div className="lld-inline-row">
            {log.performedByType === "system" ? (
              <span className="lld-icon-circle lld-icon-gray">
                <Settings size={14} color="#6B7280" />
              </span>
            ) : (
              <img
                src={AhmedAvatar}
                alt={log.performedBy}
                className="lld-avatar"
              />
            )}
            <span className="lld-value">{log.performedBy}</span>
          </div>
        </div>

        <div className="lld-field">
          <span className="lld-label">Module</span>
          <div className="lld-inline-row">
            <span
              className="lld-icon-circle"
              style={{ backgroundColor: meta.bg }}
            >
              <ModuleIcon size={14} color={meta.color} />
            </span>
            <span className="lld-value">{log.module}</span>
          </div>
        </div>

        <div className="lld-field">
          <span className="lld-label">Action</span>
          <span className="lld-value">{log.action}</span>
        </div>

        <div className="lld-field">
          <span className="lld-label">Target</span>
          <span className="lld-value">{log.target}</span>
        </div>

        {log.previousValue && (
          <div className="lld-field">
            <span className="lld-label">Previous Value</span>
            <span className="lld-pill lld-pill-blue">{log.previousValue}</span>
          </div>
        )}

        {log.newValue && (
          <div className="lld-field">
            <span className="lld-label">New Value</span>
            <span className="lld-pill lld-pill-yellow">{log.newValue}</span>
          </div>
        )}

        <div className="lld-field">
          <span className="lld-label">Reason</span>
          <span className="lld-value">{log.reason}</span>
        </div>

        <div className="lld-field">
          <span className="lld-label">Source</span>
          <span className="lld-value">{log.source}</span>
        </div>

        <div className="lld-field">
          <span className="lld-label">IP Address / System</span>
          <span className="lld-value">{log.ip}</span>
        </div>

        <div className="lld-field">
          <span className="lld-label">Additional Note</span>
          <span className="lld-value">{log.note}</span>
        </div>
      </div>
    </div>
  );
}
